import { useState, useEffect } from "react";
import { Download, X, Share } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { canUsePWA, isStandalone, isIOS } from "@/lib/pwa";

export default function InstallPrompt() {
  const { user } = useAuth();
  const [deferred, setDeferred] = useState(null);
  const [show, setShow] = useState(false);
  const ios = isIOS();

  useEffect(() => {
    if (!user || !canUsePWA(user.role) || isStandalone()) return undefined;
    if (localStorage.getItem("pwa_install_dismissed") === "1") return undefined;

    const onBip = (e) => {
      e.preventDefault();
      setDeferred(e);
      setShow(true);
    };
    window.addEventListener("beforeinstallprompt", onBip);
    if (ios) setShow(true); // iOS n'émet pas beforeinstallprompt
    return () => window.removeEventListener("beforeinstallprompt", onBip);
  }, [user, ios]);

  const dismiss = () => {
    setShow(false);
    localStorage.setItem("pwa_install_dismissed", "1");
  };

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    await deferred.userChoice;
    setDeferred(null);
    setShow(false);
  };

  if (!show) return null;

  return (
    <div data-testid="pwa-install-banner"
         className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50 w-[calc(100%-2rem)] max-w-md
                    bg-[#0F2942] text-white rounded-2xl shadow-2xl border border-sky-800/60 p-4
                    flex items-center gap-3 animate-in slide-in-from-bottom-4">
      <img src="/icons/icon-192.png" alt="" className="h-11 w-11 rounded-xl flex-shrink-0" />
      <div className="min-w-0 flex-1">
        <div className="font-semibold text-sm">Installer Path-Intelligent</div>
        <p className="text-[11px] text-sky-200 leading-snug mt-0.5">
          {ios
            ? <>Appuyez sur <Share className="inline h-3 w-3" /> puis « Sur l'écran d'accueil ».</>
            : "Ajoutez l'application à votre écran d'accueil pour un accès rapide."}
        </p>
      </div>
      {!ios && (
        <button onClick={install} data-testid="pwa-install-btn"
                className="flex items-center gap-1.5 bg-sky-600 hover:bg-sky-500 text-white text-xs
                           font-semibold rounded-full px-3 py-2 transition-colors flex-shrink-0">
          <Download className="h-3.5 w-3.5" /> Installer
        </button>
      )}
      <button onClick={dismiss} data-testid="pwa-install-dismiss"
              className="p-1.5 text-sky-300 hover:text-white flex-shrink-0">
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
